import { useTranslation } from 'react-i18next';
import customTwMerge from 'utils/twMerge';

type Props = {
  title: TFuncKeyCommonNS;
  children?: React.ReactNode;
  className?: string;
};

export default function PageTitle({ title, className, children }: Props) {
  const { t, i18n } = useTranslation('common');

  return (
    <div className={customTwMerge('mb-4 flex items-center justify-between', className)}>
      <h2 className="text-body16 text-neutral-500">
        {t(title).toLocaleUpperCase(i18n.resolvedLanguage)}
      </h2>

      {children}
    </div>
  );
}
